import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog12.css';
import blogImage from '../Asets/Blog.jpg';        // hero background
import familyImg from '../Asets/blog1212.png';    // detail image
import Header from '../components/header';
import Footer from '../components/footer';

const Blog12 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Why Family Matters: The Role of Loved Ones in Shaping Our Lives | Red School House Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 01 October 2025</div>
          <br />

          <img
            src={familyImg}
            alt="Why Family Matters - Red School House Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              At <strong>Red School House Vadodara</strong>, we believe that a child’s growth is shaped not
              only by what they learn in the classroom but also by the <strong>love and values they receive at home</strong>.
              <strong> Family is the first school of life</strong>—where children learn their earliest lessons of love,
              kindness, respect, and responsibility.
            </p>
            <p>
              No matter how the world changes, the <strong>role of family remains constant</strong>. Parents, grandparents,
              and loved ones provide the emotional support and guidance that help children grow into confident and caring individuals.
            </p>

            <h3>The Role of Loved Ones in Shaping Young Minds</h3>

            <h3>💖 1. Emotional Support</h3>
            <p>
              A hug from a parent, encouragement from grandparents, or kind words from siblings—these little gestures of love
              help children feel <strong>safe and valued</strong>. This emotional foundation makes them stronger and more resilient
              in the outside world.
            </p>

            <h3>🌱 2. Teaching Values at Home</h3>
            <p>
              Simple habits like saying thank you, helping with chores, or showing respect for elders are often learned at home
              before school. <strong>These values become lifelong lessons</strong> that guide children at every step.
            </p>

            <h3>👩‍👩‍👧‍👦 3. Building Identity and Belonging</h3>
            <p>
              Family traditions, stories, and celebrations give children a sense of identity. <strong>Knowing where they come from</strong>
              helps them feel proud of who they are and strengthens their sense of belonging.
            </p>

            <h3>🎓 4. Support in Education</h3>
            <p>
              Parents and caregivers are a child’s first teachers. Helping with homework, reading bedtime stories, or asking about
              their day at school shows children that <strong>learning is important and enjoyable</strong>.
            </p>

            <h3>🤝 5. Teaching Social Skills</h3>
            <p>
              From sharing toys with siblings to greeting relatives, children learn social behavior at home. These early interactions
              prepare them to build <strong>healthy friendships</strong> in school and beyond.
            </p>

            <h3>Family + School = A Strong Foundation</h3>
            <p>
              At <strong>Red School House Vadodara</strong>, we see education as a partnership between parents and teachers.
              While family gives the child love and values, school adds structured learning and exploration. <strong>Together, this creates
              a balanced foundation</strong> where children can thrive—academically, socially, and emotionally.
            </p>

            <h3>About Red School House Vadodara</h3>
            <p>
              At <strong>Red School House Vadodara</strong>, every day is a new opportunity to nurture young minds.
              Recognized as the <strong>Best Nursery School in Vadodara</strong>, we focus on playful learning, storytelling,
              and hands-on activities that spark curiosity. With small class sizes and caring teachers, we provide a secure
              environment where children feel at home while learning.
            </p>

            <p>
              <strong>Address:</strong> A-25, Castle White, Opposite Main, Harni Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong> +91 7778851070
              <br />
              <strong>Email:</strong> redschoolhousebaroda2025@gmail.com
              <br />
              <strong>Website:</strong>{' '}
              <a href="https://redhouseschoolvadodara.in/" target="_blank" rel="noreferrer">
                redhouseschoolvadodara.in
              </a>
              <br />
              <strong>Instagram:</strong>{' '}
              <a href="https://www.instagram.com/redschoolhousebaroda" target="_blank" rel="noreferrer">
                @redschoolhousebaroda
              </a>
              <br />
              <strong>Google Business Profile:</strong>{' '}
              <a href="https://www.google.com/search?q=Red+School+House+Vadodara" target="_blank" rel="noreferrer">
                Click Here
              </a>
            </p>

            <h3>Final Thoughts</h3>
            <p>
              <strong>Family lays the foundation; school helps it grow.</strong> With love at home and joyful learning in school,
              children develop confidence, compassion, and character—qualities that guide them for life.
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog12;
